import React from 'react';
export function HeroSection() {
  return <section className="relative w-full flex flex-col text-center px-5 py-8 sm:py-16 items-center justify-center bg-[#0A0A0A]" data-id="element-131">
      {/* Logo */}
      <span className="text-[#FF6B00] text-lg sm:text-xl font-black tracking-widest mb-3 uppercase" data-id="element-132">
        🏀 BASKETBALL READY 360
      </span>

      {/* Badge */}
      <div className="mb-4" data-id="element-133">
        <span className="bg-[#FF6B00]/10 text-[#FF6B00] text-[10px] sm:text-xs font-bold px-3 py-1.5 rounded-full uppercase tracking-wide border border-[#FF6B00]/20" data-id="element-134">
          🏀 Trusted by hundreds of coaches worldwide
        </span>
      </div>

      {/* Main headline */}
      <h1 className="font-black text-white max-w-4xl text-3xl sm:text-5xl md:text-7xl leading-[1.1] mb-4 tracking-tight" data-id="element-135">
        Plan Your Entire Basketball Year{' '}
        <span className="text-[#FF6B00]" data-id="element-136">In Under 5 Minutes.</span>
      </h1>

      {/* Subheadline */}
      <p className="text-[#B0B0C0] text-sm sm:text-lg max-w-2xl mx-auto mb-5 font-medium leading-relaxed" data-id="element-137">
        The complete basketball bible for coaches and PE teachers — 200+
        sessions, 101 shooting drills, tactics, planning tools and more.
        Everything done for you.
      </p>

      {/* Bullets — compact */}
      <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 mb-6 max-w-2xl" data-id="element-138">
        {['6 Volumes', '5 Bonuses', '200+ Sessions', '101 Drills', 'All Age Groups'].map((item, i) => <div key={i} className="flex items-center gap-1.5" data-id="element-139">
            <span className="text-[#00C853] text-sm" data-id="element-140">✅</span>
            <span className="text-white text-xs sm:text-sm font-semibold" data-id="element-141">
              {item}
            </span>
          </div>)}
      </div>

      {/* Mockup image — smaller */}
      <div className="relative w-full max-w-[220px] sm:max-w-[360px] mx-auto mb-6" data-id="element-142">
        <img src="https://cdn.magicpatterns.com/uploads/mc4uBy6kEVsGDkCRAsGaMz/ChatGPT_Image_15_jun_2026,_13_29_32-Photoroom.png" alt="BASKETBALL READY 360 — The Complete Kit" className="w-full h-auto object-contain drop-shadow-2xl" width={600} height={600} fetchPriority="high" data-id="element-143" />
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-3/4 h-10 bg-[#FF6B00] opacity-20 rounded-full pointer-events-none" style={{
        filter: 'blur(40px)'
      }} data-id="element-144" />
      </div>

      {/* CTA Button */}
      <a href="#pricing" className="btn-cta-green font-black text-base sm:text-2xl px-6 sm:px-12 py-4 sm:py-6 rounded-2xl transition-colors inline-block mb-4 w-full sm:w-auto max-w-md shadow-xl" data-id="element-145">
        🚀 GET BASKETBALL READY 360 NOW — ONLY $27
      </a>

      {/* Trust badges */}
      <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-6 text-[#B0B0C0] text-[11px] sm:text-sm font-medium" data-id="element-146">
        <span className="flex items-center gap-1.5" data-id="element-147">🔒 Secure Payment</span>
        <span className="flex items-center gap-1.5" data-id="element-148">⚡ Instant Access</span>
        <span className="flex items-center gap-1.5" data-id="element-149">🛡️ 7-Day Guarantee</span>
      </div>
    </section>;
}